<script lang="ts" setup>
  import { computed } from 'vue';
  import type { MpfLabelProps } from './MpfLabel.props';
  import { mpfLabelDefaults } from './MpfLabel.props';
  import './MpfLabel.scss';

  const props = withDefaults(defineProps<MpfLabelProps>(), mpfLabelDefaults);

  defineOptions({
    name: 'MpfLabel',
  });

  const hasLabel = computed(() => !!props.label?.trim());

  const headingTag = computed(() => {
    if (!props.headingLevel) return 'span';
    return `h${props.headingLevel}` as const;
  });

  const labelClasses = computed(() => [
    'mpf-label',
    props.headingLevelSize && `mpf-label--${props.headingLevelSize}`,
    props.labelClass,
  ]);
</script>

<template>
  <label
    v-if="hasLabel"
    :for="forId"
    :class="labelClasses"
    :aria-label="ariaLabel || undefined"
    :aria-describedby="ariaDescribedby || undefined"
  >
    <component :is="headingTag" class="mpf-label__text">
      {{ label }}
    </component>
  </label>
</template>
